<template>
  <div id="insights">
    <v-container :fluid="$vuetify.breakpoint.lgAndDown">
      <v-card elevation="7" color="card" class="rounded-xl">
        <v-toolbar color="toolbar">
          <v-toolbar-title>Insights</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            label="User ID or username"
            single-line
            hide-details
            v-model="userId"
            @keyup.enter="$refs.insights.getInsights()"
          ></v-text-field>
          <v-btn icon dark @click="$refs.insights.getInsights()">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </v-toolbar>
        <v-tabs background-color="card">
          <v-spacer></v-spacer>
          <v-tab>
            <v-icon>mdi-account</v-icon>
            <span class="ml-2">Your Insights</span>
          </v-tab>
          <v-tab>
            <v-icon>mdi-pulse</v-icon>
            <span class="ml-2">Pulse</span>
          </v-tab>
          <v-tab>
            <v-icon>mdi-chart-bar</v-icon>
            <span class="ml-2">Leaderboard</span>
          </v-tab>
          <v-tab>
            <v-icon>mdi-account-group</v-icon>
            <span class="ml-2">Global</span>
          </v-tab>
          <v-spacer></v-spacer>
          <v-tab-item
            touchless
            :style="
              'background-color: ' +
              $vuetify.theme.themes[$vuetify.theme.dark ? 'dark' : 'light'].card
            "
          >
            <InsightsStandalone ref="insights" :id="userId" />
          </v-tab-item>
          <v-tab-item touchless><PulseStandalone></PulseStandalone></v-tab-item>
          <v-tab-item
            :style="
              'background-color: ' +
              $vuetify.theme.themes[$vuetify.theme.dark ? 'dark' : 'light'].card
            "
          >
            <!-- leaderboard -->
            <v-container v-if="leaderboard">
              <v-toolbar color="toolbar">
                <v-toolbar-title>Leaderboard</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  label="Search"
                  hide-details
                ></v-text-field>
              </v-toolbar>
              <v-data-table
                :items="leaderboard.leaderdata"
                :headers="leaderboardHeaders"
                @click:row="$router.push('/u/' + $event.username)"
                style="cursor: pointer"
                :items-per-page="-1"
              >
                <template v-slot:item.rank="{ item }">
                  {{ leaderboard.leaderdata.indexOf(item) + 1 }}
                </template>
              </v-data-table>
            </v-container>
          </v-tab-item>
          <v-tab-item
            touchless
            :style="
              'background-color: ' +
              $vuetify.theme.themes[$vuetify.theme.dark ? 'dark' : 'light'].card
            "
          >
            <GlobalInsightsStandalone ref="insights" :id="userId" />
          </v-tab-item>
        </v-tabs>
      </v-card>
    </v-container>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import InsightsStandalone from "@/components/InsightsStandalone"
import PulseStandalone from "@/components/PulseStandalone"
import GlobalInsightsStandalone from "@/components/GlobalInsightsStandalone"
import AjaxErrorHandler from "@/lib/errorHandler"

export default {
  name: "Insights",
  components: {
    InsightsStandalone,
    PulseStandalone,
    GlobalInsightsStandalone
  },
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: false
        }
      },
      search: "",
      userId: "",
      leaderboard: null,
      leaderboardHeaders: [
        { text: "Rank", value: "rank" },
        { text: "Username", value: "username" },
        { text: "Uploads", value: "uploads" },
        { text: "Percentage of Total", value: "percentage" }
      ],
      flagHeaders: [
        {
          text: "ID",
          value: "id"
        },
        {
          text: "Name",
          value: "name"
        },
        {
          text: "Count",
          value: "count"
        }
      ],
      school: {
        registrationGraph: [],
        registrationGraphLabels: [],
        registrationCount: 0,
        activeCount: 0,
        users: [],
        flags: [],
        loading: true,
        insights: null
      }
    }
  },
  methods: {
    differenceIcon(diff, reverse = false) {
      if (!reverse) {
        if (diff > 0) {
          return {
            icon: "mdi-arrow-up-circle",
            color: "success"
          }
        } else if (diff < 0) {
          return {
            icon: "mdi-arrow-down-circle",
            color: "red"
          }
        } else {
          return {
            icon: "mdi-minus-circle",
            color: "warning"
          }
        }
      } else {
        if (diff > 0) {
          return {
            icon: "mdi-arrow-up-circle",
            color: "red"
          }
        } else if (diff < 0) {
          return {
            icon: "mdi-arrow-down-circle",
            color: "success"
          }
        } else {
          return {
            icon: "mdi-minus-circle",
            color: "warning"
          }
        }
      }
    },
    getLeaderboard() {
      this.axios
        .get("/api/v1/insights/leaderboard")
        .then((res) => {
          this.leaderboard = res.data
        })
        .catch(() => {})
    }
  },
  mounted() {
    this.getLeaderboard()
  }
}
</script>

<style scoped></style>
